module.exports = __webpack_public_path__ + "static/media/bluetooth-integration (2).ab0eab75.jpg";